// Hero Portofoliu (slider + boxes template: hero-portfolio): one Swiper per section,
// with its own arrows and "1/6" counter, so several instances can share a page.
$(document).ready(function () {
	if (typeof Swiper === 'undefined') {
		return;
	}

	$('[data-hero-portfolio]').each(function () {
		const section = this;
		const container = section.querySelector('.hero-portfolio__swiper');
		const counter = section.querySelector('.hero-portfolio__counter');
		const autoplay = parseInt(section.getAttribute('data-autoplay'), 10) || 0;

		if (!container || container.querySelectorAll('.swiper-slide').length < 2) {
			return;
		}

		new Swiper(container, {
			slidesPerView: 1,
			speed: 700,
			loop: true,
			keyboard: { enabled: true, onlyInViewport: true },
			autoplay: autoplay > 0 ? { delay: autoplay * 1000, disableOnInteraction: false } : false,
			navigation: {
				prevEl: section.querySelector('.hero-portfolio__arrow--prev'),
				nextEl: section.querySelector('.hero-portfolio__arrow--next'),
			},
			pagination: {
				el: counter,
				type: 'fraction',
				renderFraction: function (currentClass, totalClass) {
					return '<span class="' + currentClass + '"></span>/<span class="' + totalClass + '"></span>';
				},
			},
		});
	});
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/hero-portfolio.js